import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-approval",
  "use": "icon-menu-approval-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-menu-approval\">\r\n<path d=\"M100.2,0h55.4v55.5c0,30.7-24.8,55.5-55.4,55.5S44.7,86.2,44.7,55.5S69.4,0,100.2,0z M50.2,122.2H150\r\n\tc21.5,0,38.7,17.4,38.7,38.8v5.6c0,18.4-15,33.4-33.3,33.4H44.7c-18.5-0.1-33.3-15.1-33.3-33.5V161\r\n\tC11.4,139.6,28.8,122.2,50.2,122.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol